import { FormulaireReponduAdmin } from '@/domain/FormulaireReponseAdmin'
import { Formulaire_Reponse_Statut } from '@/domain/Formulaire_Reponse_Statut'
import _ from 'lodash'
import mixins from 'vue-typed-mixins'
import globalMixin from '../globalMixin'
import { FormulaireOutput } from './models/formulaire'
import { HubConnectionBuilder } from '@microsoft/signalr'
import { Files } from '@/global/requesting/requester'
import { Capacitor } from '@capacitor/core'
import { Filesystem, Directory, Encoding } from '@capacitor/filesystem'
import Openable from '@/global/viewmodels/openable'
import SendMailModel from '@/layout/model/SendMailModel'

export default mixins(globalMixin).extend({
    data() {
        return {
            formulairesReponses: [] as FormulaireReponduAdmin[],
            formulairesModeles: [] as FormulaireOutput[],
            idModele: this.$route.params.idModele || ('' as string),
            filterOrtho: true,
            filterDentaire: true,
            commentaireFormulaire: null as null | string,
            idFormulaire: null as null | number,
            dialogFormulaire: new Openable(),
            dialogMail: new Openable(),
            mail: new SendMailModel(),
        }
    },
    methods: {
        loadAllReponses() {
            this.$loader.go()
            this.$http
                .api(`formulaireReponse/all?idModeleFormulaire=${this.idModele || ''}&ortho=${this.filterOrtho}&dentaire=${this.filterDentaire}`)
                .get()
                .then(x => {
                    this.formulairesReponses = x.data
                })
                .catch(x => this.$swal.toast.errorApi(x))
                .finally(() => this.$loader.stop())
        },
        loadAllModelesFormulaires() {
            this.$loader.go()
            this.$http
                .api(`formulaire/all`)
                .get()
                .then(x => {
                    this.formulairesModeles = x.data
                })
                .catch(x => this.$swal.toast.errorApi(x))
                .finally(() => this.$loader.stop())
        },
        setStatut(id: number, statut: Formulaire_Reponse_Statut) {
            this.$loader.go()
            this.$http
                .api(`formulaireReponse/change-statut`)
                .post({ idFormulaireReponse: id, statut: statut })
                .then(x => {
                    this.$swal.toast.success()
                    this.loadAllReponses()
                    this.loadPastilles()
                })
                .catch(x => this.$swal.toast.errorApi(x))
                .finally(() => this.$loader.stop())
        },
        changeCommentaire(formulaireReponse: FormulaireReponduAdmin) {
            this.idFormulaire = formulaireReponse.id
            this.commentaireFormulaire = formulaireReponse.commentaire
            this.dialogFormulaire.open()
        },
        saveNewCommentaire() {
            this.$loader.go()
            this.$http
                .api(`formulaireReponse/change-commentaire`)
                .patch({ id: this.idFormulaire, commentaire: this.commentaireFormulaire })
                .then(x => {
                    this.$swal.toast.success()
                    this.loadAllReponses()
                    this.dialogFormulaire.close()
                })
                .catch(x => this.$swal.toast.errorApi(x))
                .finally(() => this.$loader.stop())
        },
        downloadFichierReponsesExcel(id: number) {
            this.$http
                .api(`formulairereponse/get-url-fichier-excel?input=${id}`)
                .get()
                .then(x => {
                    if (Capacitor.isNativePlatform()) {
                        window.location.href = this.$http.baseUrl + `/formulairereponse/get-excel?input=${x.data}`
                    } else {
                        window.location.href = this.$http.baseUrl + `/formulairereponse/get-excel?input=${x.data}`
                    }
                })
                .catch(x => this.$swal.toast.errorApi(x))
                .finally(() => this.$loader.stop())
        },
        formatDate(date: string) {
            return new Date(date).toLocaleDateString('fr-FR')
        },
        openEnvoiMail(demande: FormulaireReponduAdmin) {
            // this.modalEnvoiMailDemandeReeditionFacture(demande) // OLD version

            this.mail = new SendMailModel()
            this.mail.mail = demande.userMail
            this.mail.id = demande.id
            this.dialogMail.open()
        },
        envoyerMail(mail: SendMailModel) {
            const formData = new FormData()

            if (!mail) return

            formData.append('idFormulaireReponse', mail.id.toString())
            if (!mail.mail) {
                this.$swal.toast.error('Aucun mail renseigné.')
                return
            }
            formData.append('mail', mail.mail)

            if (!mail.corps) {
                this.$swal.toast.error('Aucun corps renseigné.')
                return
            }
            formData.append('corps', mail.corps)


            for (const file of mail.files) {
                formData.append('files', file)
            }

            this.$loader.go()

            this.$http
                .api('formulairereponse/send-mail')
                .post(formData)
                .then(x => {
                    this.$swal.toast.success("Le mail a bien été envoyé.")
                })
                .catch(x => this.$swal.toast.errorApi(x))
                .finally(() => this.$loader.stop())
        }
    },
    mounted() {
        this.loadAllModelesFormulaires()
        this.loadAllReponses()

        const connection = new HubConnectionBuilder().withUrl(process.env.VUE_APP_API_URL + '/hubs/refresh').build()
        connection.start().then(() => {
            connection.on('RefreshReponsesFormulaires', () => {
                this.loadAllReponses()
            })
        })
    },
    computed: {
        selectListModeles(): { text: string; value: string }[] {
            const res = _.map(this.formulairesModeles, modele => {
                return {
                    value: modele.id.toString(),
                    text: modele.nom
                }
            })
            res.unshift({ text: 'Tous', value: '' })

            return res
        }
    },
    watch: {
        filterOrtho() {
            this.loadAllReponses()
        },
        filterDentaire() {
            this.loadAllReponses()
        }
    }
})
